<template>
  <div id="page-wrap">
    <div class="container">
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade in active">
          <div class="mychilidTab-box clearfix">
            <ul class="nav nav-tabs child-tabs">
              <router-link :to="{name: 'grouplist'}" tag="li">
                <a>我的群组</a>
              </router-link>
              <!-- <router-link :to="{name: 'groupmsg'}" tag="li">
                <a>
                  <span>待处理消息</span>
                  <span class="badge" v-show="requestNums">{{requestNums}}</span>
                </a>
              </router-link> -->
            </ul>
            <!-- <div class="button-container shown" v-show="$route.name === 'grouplist'">
              <a class="btn-group-plus" @click="createGroup" v-if="right__group">
                <i class="iconfont icon-newgroup"></i>
                创建群组
              </a>
              <a class="btn-group-plus" @click="addGroup" v-if="right__groupApply">
                <i class="iconfont icon-group-plus"></i>
                加入群组
              </a>
            </div> -->
          </div>
          <div class="tab-content clearfix">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupList",
  created() {
    this.$store.commit("SET_THEME", "群组");
  },
  computed: {
    right__group () {
      return this.$store.getters.right__group
    },
    right__groupApply () {
      return this.$store.getters.right__groupApply
    },
    requestNums() {
      return this.$store.state.grouplist.requestNums;
    }
  },
  methods: {
    createGroup() {
      $("#newgroup").modal("show");
    },
    addGroup() {
      $("#addgroup").modal("show");
    }
  }
};
</script>

<style scoped>
.shown {
  display: block;
}
</style>